<template>
  <span>
    <h1 class="font-bold text-3xl md:text-5xl">My Profile</h1>
    <p class="my-4 text-1xl md:text-3xl">The data went missing. We are working hard and fast to bring it back.</p>
    <p class="text-1xl md:text-3xl">
      If you keep seeing this message
      <a href="https://genpact-myit.onbmc.com/dwp/app/#/srm/profile/SRGDUMLPEFM11AQ278SCQ194FAZ58C/srm" target="_blank" rel="noopener noreferrer" class="apianchortag font-bold italic no-underline hover:underline">click here</a> to generate
      a ticket in Helpmate.
    </p>
  </span>
</template>

<script>
export default { name: 'Apierrormessage' };
</script>
